import { render } from "./DocumentationView.vue?vue&type=template&id=7ae2c368&scoped=true"
import script from "./DocumentationView.vue?vue&type=script&lang=js"
export * from "./DocumentationView.vue?vue&type=script&lang=js"

import "./DocumentationView.vue?vue&type=style&index=0&id=7ae2c368&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae2c368"]])

export default __exports__